import React, { Fragment, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ActionButton, checkoutUrl } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 55 * 60 + 21);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-brand-dark" data-id="element-96" data-mp="20s3bv92hhl6h">
      <div className="bg-[#1c0909] px-4 py-16 sm:py-20" data-id="element-97" data-mp="3h6v49lzmqsfs">
        <div className="mx-auto max-w-4xl text-center" data-id="element-98" data-mp="3h9hczoy9bdzl">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-99" data-mp="3c78iup9ne5vw">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" data-id="element-100" data-mp="3vz6xzp9gm9ls">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-101" data-mp="erbkjm49pzz7" data-mpi={index}>
                <div data-id="element-102" data-mp="eqac7pemzrl6">
                  <p className="font-display text-5xl font-bold text-red-500 sm:text-7xl" data-id="element-103" data-mp="eqtkeeehj1m0">{value}</p>
                  <p className="text-xs tracking-[.2em] text-slate-400" data-id="element-104" data-mp="3dasb9e66dhqs">{label}</p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-red-500 sm:text-6xl" data-id="element-105" data-mp="3n7evc0qog4rr">:</span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-slate-400" data-id="element-106" data-mp="3rz6cxlruv05r">
            Después sube. <b className="text-white" data-id="element-107" data-mp="2uj96b1slbtm4">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-red-500/20 bg-brand-ink p-4 text-left" data-id="element-108" data-mp="2zhkhpgyjac6g">
            <div className="flex justify-between text-sm font-medium text-red-400" data-id="element-109" data-mp="2rgcvtv8sadv9">
              <span data-id="element-110" data-mp="2mhrtnq9z1k46">Cupos al precio de lanzamiento</span>
              <span data-id="element-111" data-mp="2mh8m93hy6e4e">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-800" data-id="element-112" data-mp="3177ih0pxzfh8">
              <div className="h-full w-[72%] rounded-full bg-red-500" data-id="element-113" data-mp="2w7l3alqjzp5s" />
            </div>
            <p className="mt-2 text-right text-xs text-slate-500" data-id="element-114" data-mp="2w9xn74fvg9lh">72% de los cupos ya tomados</p>
          </div>
        </div>
      </div>

      <div className="px-4 py-16 sm:py-24" data-id="element-115" data-mp="23jpd7zvhovhz">
        <div className="mx-auto max-w-2xl" data-id="element-116" data-mp="23l0f1u5djt6g">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-117" data-mp="2igpv7bnvpc39">
            TU SISTEMA COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-8 rounded-3xl border-2 border-brand-green bg-brand-ink p-6 shadow-[0_0_30px_rgba(22,163,74,.13)] sm:p-9" data-id="element-118" data-mp="2dgajeoj8wcne">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-119" data-mp="59zy6zuzn9rt">
              <div data-id="element-120" data-mp="3nf38cyztabz3">
                <h3 className="font-display text-lg font-bold text-brand-light" data-id="element-121" data-mp="3nfl9oa1bzgdv">
                  🌿 SISTEMA INFORMACIÓN BAJO CONTROL™
                </h3>
                <p className="mt-1 text-sm text-slate-400" data-id="element-122" data-mp="3rirfxhog17kc">
                  3 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-brand-light" data-id="element-123" data-mp="o0hlgox1xd5s">
                  Todo el sistema en PDF + 5 bonos estratégicos de regalo.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-124" data-mp="ea56dc80ac71">
                <p className="text-slate-500 line-through" data-id="element-125" data-mp="e8tzh3j9kobp">$65.000</p>
                <p className="font-display text-4xl font-bold text-brand-light" data-id="element-126" data-mp="11zhc2244k24l">$19.990</p>
                <p className="text-xs text-slate-400" data-id="element-127" data-mp="16qze6thvw8r5">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" href={checkoutUrl} showTrust data-id="element-128" data-mp="3f8jvmcafmj5r">
            🧠 QUIERO MI SISTEMA AHORA
          </ActionButton>
        </div>
      </div>
    </section>;
}